<template>
  <g>
    <g
      v-for="(el, elIndex) in elements"
      :key="`${el.depth}-${elIndex}`"
      :class="`${vizSwitchSel(el.depth)} ${el.depth}`"
    >
      <rect
        :class="[
          'main-rect',
          { selected: ancestorsIds.includes(el.data.id) },
          { isTransitioning: isTransitioning }
        ]"
        :style="{ transitionDuration: transitionDuration / 1000 + 's' }"
        :x="xScale(el.depth - 1)"
        :y="yScalePos(el.data.progress[vizSwitchSel(el.depth)])"
        :height="yScaleHeight(el.data.weight[vizSwitchSel(el.depth)])"
        :width="elementsWidth"
        @click="$emit('click', el)"
        @mousemove="setMainVizTooltipFunc($event)"
        @mouseenter="setMainVizTooltip(el)"
        @mouseleave="setMainVizTooltip(null)"
      />
      <text
        :class="['text', { selected: ancestorsIds.includes(el.data.id) }]"
        :x="
          xScale(el.depth - 1) + ($tvaMq !== 'desktop' ? elementsWidth / 2 : 0)
        "
        :y="
          yScalePos(el.data.progress[vizSwitchSel(el.depth)]) +
            yScaleHeight(el.data.weight[vizSwitchSel(el.depth)]) / 2 +
            5
        "
        v-if="textIsVisible(el)"
      >
        {{ el.data.name }}
      </text>
      <viz-element-comp
        v-if="el.children"
        :elements="el.children"
        :elementsWidth="elementsWidth"
        :xScale="xScale"
        :yScalePos="yScalePos"
        :yScaleHeight="yScaleHeight"
        :ancestorsIds="ancestorsIds"
        :isTransitioning="isTransitioning"
        :transitionDuration="transitionDuration"
        :vizSwitchSel="vizSwitchSel"
        @click="$emit('click', $event)"
      />
    </g>
  </g>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "viz-element-comp",
  props: [
    "elements",
    "elementsWidth",
    "xScale",
    "yScalePos",
    "yScaleHeight",
    "ancestorsIds",
    "isTransitioning",
    "transitionDuration",
    "vizSwitchSel"
  ],
  methods: {
    textIsVisible(el) {
      let height = this.yScaleHeight(
        el.data.weight[this.vizSwitchSel(el.depth)]
      );
      return !this.isTransitioning && height > 20;
    },
    setMainVizTooltipFunc(event) {
      this.setMainVizTooltipPos({
        x: event.clientX,
        y: event.clientY
      });
    },
    ...mapActions(["setMainVizTooltip", "setMainVizTooltipPos"])
  },

  computed: {
    ...mapGetters(["getVizElSelected", "getNormalizeViz", "getFilterViz"])
  }
};
</script>

<style lang="scss" scoped>
g {
  pointer-events: none;
}
.main-rect {
  pointer-events: all;
  fill: none;
  stroke: #fff;
  stroke-width: 0.1px;
  cursor: pointer;
  transition: none;
  &.isTransitioning {
    transition: x 0.8s ease, y 0.8s ease, width 0.8s ease, height 0.8s ease;
  }

  &.selected {
    stroke-width: 2px;
  }
}
text {
  @include ButtonS;
  fill: #fff;
  transform: translateX(10px);
  animation: fade 0.3s ease;
  transition: opacity 0.3s ease;
  opacity: 0.6;
  font-size: 13px;
  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 0.6;
    }
  }

  &.selected {
    opacity: 1;
  }
  .mobile &,
  .tablet & {
    opacity: 1;
    text-anchor: middle;
    transform: translateX(0);
  }
}
</style>
